import type { ReactNode } from "react";

import { cn } from "@repo/ui/lib/utils";
import type {
  BoardingPassSection,
  CommonInfoSection,
  PriorityBoardingSection,
} from "@repo/ui/types/cms";

import FlightRouteHeader from "./FlightRouteHeader";
import TravelPackInfoCardRenderer from "./TravelPackInfoCardRenderer";

type FlightSegmentCardProps = {
  direction?: string;
  directionLabel?: string;
  disabled?: boolean;
  bundleCode?: string;
  InBundleInAnyJourney?: boolean;
  children?: ReactNode;
  cmsData?: BoardingPassSection | PriorityBoardingSection;
  isError?: boolean;
  commonInfo?: CommonInfoSection;
};

export default function FlightSegmentCard({
  direction,
  directionLabel,
  disabled = false,
  bundleCode,
  InBundleInAnyJourney,
  children,
  cmsData,
  isError = false,
  commonInfo,
}: Readonly<FlightSegmentCardProps>) {
  const shouldShowPackInfo = InBundleInAnyJourney && disabled;

  return (
    <>
      {shouldShowPackInfo && (
        <div className="mb-2">
          <TravelPackInfoCardRenderer
            bundleCode={bundleCode}
            InBundleInAnyJourney={InBundleInAnyJourney}
            cmsData={cmsData}
            disabled={disabled}
          />
        </div>
      )}

      <div
        className={cn(
          "bg-muted flex flex-col-reverse rounded-xl md:flex-row",
          disabled && "pointer-events-none opacity-65",
          isError && "bg-[#f9d4d8]",
        )}
        data-testid="flight-segment-card-section"
      >
        <div className="flex h-full w-full flex-col space-y-2 rounded-xl p-3">
          <FlightRouteHeader direction={direction} directionLabel={directionLabel} />

          {children}

          {isError && (
            <div className="w-full flex justify-center mb-2">
              <div className="min-w-71 min-h-9 text-center text-brand-blue bg-[#FFBEC2] rounded-lg px-3 py-2 text-sm">
                {commonInfo?.noOptionSelectedMessage ?? "Debes seleccionar tu opción"}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
